// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"HideableContainer_mainContainer__1oe6s","mainContainerHidden":"HideableContainer_mainContainerHidden__1B0Qa"};